import * as mutations from './mutations'

export default {
  namespaced: true,
  data () {
    return {
      url: undefined,
      type: undefined,
      subtype: undefined,
      ticketId: undefined,
      fichero: undefined,
      err: undefined
    }
  },
  mutations
}
